import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SearchBar from '@/components/feature/SearchBar';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import MovieGridSection from '@/pages/home/components/MovieGridSection';
import HotRankList from '@/pages/home/components/HotRankList';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { usePageMeta } from '@/hooks/usePageMeta';
import { getFeaturedMovies, getLatestMovies, getHotMovies } from '@/lib/movieUtils';

export default function Home() {
  usePageMeta({
    title: '国语影音资源库高清影音资源集锦',
    description:
      '国语影音资源库网站汇集丰富的影视影音资源，涵盖国语对白相关内容，方便用户查询和了解多样影音作品。',
    keywords: '国语影音资源库,国语对白,影音资源,视频内容,影视作品,国语视频,影音合集',
  });

  const featured = getFeaturedMovies();
  const latest = getLatestMovies(8);
  const hot = getHotMovies(5);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <HeroCarousel movies={featured} />

        <div className="max-w-[1280px] mx-auto px-4 md:px-8">
          <div className="relative z-20 -mt-7 md:-mt-8 max-w-3xl mx-auto bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
            <p className="text-center text-sm text-foreground-600 mb-3">
              搜索你想看的国语影音资源
            </p>
            <SearchBar size="lg" />
          </div>
        </div>

        <div className="mt-12 md:mt-16 space-y-12 md:space-y-16">
          <CategoryShortcuts />
          <MovieGridSection
            title="最新更新"
            subtitle="按更新时间排序的最新国语影音资源"
            movies={latest}
            moreTo="/category/movie"
          />
          <HotRankList movies={hot} />
        </div>

        <div className="mt-12 md:mt-16">
          <SiteIntro />
        </div>
      </main>
      <Footer />
    </div>
  );
}